<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <!-- 顶部搜索栏（PC 折叠版） -->
        <div class="search-bar">
          <!-- 折叠/展开按钮 -->
          <el-button
            icon="el-icon-arrow-down"
            type="text"
            @click="toggleSearch"
            style="margin-right: 10px"
          >
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </el-button>

          <!-- 搜索项区域 -->
          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              alignItems: 'center',
              gap: '10px',
              flexWrap: 'wrap',
            }"
          >
            <el-input
              v-model="searchParams.name"
              placeholder="请输入权限名称"
              clearable
              style="width: 220px"
            ></el-input>
          </div>

          <!-- 搜索/重置/添加 始终显示 -->
          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="getMenuList"
            >
              搜索
            </el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">
              重置
            </el-button>
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="openAddDialog"
            >
              添加权限
            </el-button>
          </div>
        </div>

        <!-- 表格 -->
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="父级菜单名称" prop="pid_menu_name" min-width="150" />
          <el-table-column label="权限名称" prop="name" min-width="150" />
          <el-table-column label="接口地址" prop="url" min-width="180" />
          
          <el-table-column
            label="所属菜单ID"
            prop="menu_id"
            width="120"
            align="center"
          />
          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="更新时间" prop="updated_at" width="180" />
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
                style="color: #f56c6c"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 添加弹窗 -->
        <el-dialog
          title="添加权限"
          :visible.sync="addDialogVisible"
          width="500px"
          @close="resetAddForm"
          append-to-body
        >
          <el-form
            :model="addForm"
            :rules="addRules"
            ref="addForm"
            label-width="100px"
          >
            <el-form-item label="权限名称" prop="name">
              <el-input
                v-model="addForm.name"
                placeholder="请输入权限名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="接口地址" prop="url">
              <el-input
                v-model="addForm.url"
                placeholder="请输入接口地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="父级菜单">
              <el-select
                v-model="addForm.pid"
                placeholder="请选择父级菜单"
                @change="getChildMenu"
              >
                <el-option
                  v-for="item in menu_data"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属菜单" prop="menu_id">
              <el-select v-model="addForm.menu_id" placeholder="请选择所属菜单">
                <el-option
                  v-for="item in childMenuList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="addDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitAddMenu"
              >确认添加</el-button
            >
          </div>
        </el-dialog>

        <!-- PC 编辑弹窗 -->
        <el-dialog
          title="编辑权限"
          :visible.sync="editDialogVisible"
          width="500px"
          @close="resetEditForm"
          append-to-body
        >
          <el-form
            :model="editForm"
            :rules="addRules"
            ref="editForm"
            label-width="100px"
          >
            <el-form-item label="权限名称" prop="name">
              <el-input
                v-model="editForm.name"
                placeholder="请输入权限名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="接口地址" prop="url">
              <el-input
                v-model="editForm.url"
                placeholder="请输入接口地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="父级菜单">
              <el-select
                v-model="editForm.pid"
                placeholder="请选择父级菜单"
                @change="getChildMenuEdit"
              >
                <el-option
                  v-for="item in menu_data"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属菜单" prop="menu_id">
              <el-select
                v-model="editForm.menu_id"
                placeholder="请选择所属菜单"
              >
                <el-option
                  v-for="item in childMenuList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="editDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitEditMenu"
              >确认修改</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端（卡片列表） ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-menu-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 移动端搜索（折叠） -->
        <div class="mobile-search-group">
          <el-button
            type="text"
            icon="el-icon-arrow-down"
            @click="toggleSearch"
            style="width: 100%; text-align: left; padding-left: 0"
          >
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </el-button>

          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-input
              v-model="searchParams.name"
              placeholder="权限名称"
              clearable
              size="medium"
              prefix-icon="el-icon-search"
            />
          </div>
        </div>

        <div style="display: flex; gap: 8px; margin-bottom: 10px">
          <el-button
            type="primary"
            plain
            round
            @click="getMenuList"
            style="flex: 1"
            >搜索</el-button
          >
          <el-button plain round @click="resetSearch" style="flex: 1"
            >重置</el-button
          >
          <el-button
            type="success"
            plain
            round
            @click="openAddDialogMobile"
            style="flex: 1"
            >添加</el-button
          >
        </div>

        <!-- 移动端卡片列表 -->
        <div class="mobile-card-list">
          <div class="mobile-card" v-for="item in tableData" :key="item.id">
            <div class="card-header">
              <div class="info">
                <div class="name">{{ item.name }}</div>
                <div class="id">ID: {{ item.id }}</div>
              </div>
            </div>

            <div class="card-body">
              <div>接口：{{ item.url || "-" }}</div>
              <div>所属菜单ID：{{ item.menu_id || "-" }}</div>
              <div style="font-size: 12px; color: #999; margin-top: 4px">
                创建：{{ item.created_at }}
              </div>
            </div>

            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="handleEditMobile(item)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                round
                @click.stop="handleDelete(item)"
                >删除</el-button
              >
            </div>
          </div>
        </div>

        <!-- 移动端分页（已优化布局） -->
        <div class="mobile-pagination-wrapper">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="prev, pager, next"
            :total="pageInfo.total"
            background
            small
          />
        </div>

        <!-- ====================== 移动端 独立弹窗 ====================== -->
        <!-- 移动端添加 -->
        <el-dialog
          title="添加权限"
          :visible.sync="addDialogVisibleMobile"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          @close="resetAddForm"
          append-to-body
        >
          <el-form
            :model="addForm"
            :rules="addRules"
            ref="addForm"
            label-width="80px"
            size="medium"
          >
            <el-form-item label="权限名称" prop="name">
              <el-input
                v-model="addForm.name"
                placeholder="权限名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="接口地址">
              <el-input v-model="addForm.url" placeholder="接口地址"></el-input>
            </el-form-item>
            <el-form-item label="父级菜单">
              <el-select
                v-model="addForm.pid"
                placeholder="父级菜单"
                @change="getChildMenu"
                size="medium"
              >
                <el-option
                  v-for="item in menu_data"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属菜单">
              <el-select
                v-model="addForm.menu_id"
                placeholder="所属菜单"
                size="medium"
              >
                <el-option
                  v-for="item in childMenuList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>

          <div
            slot="footer"
            style="display: flex; justify-content: flex-end; gap: 10px"
          >
            <el-button size="medium" @click="addDialogVisibleMobile = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="submitAddMenuMobile"
              >确认添加</el-button
            >
          </div>
        </el-dialog>

        <!-- 移动端编辑 -->
        <el-dialog
          title="编辑权限"
          :visible.sync="editDialogVisibleMobile"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          @close="resetEditForm"
          append-to-body
        >
          <el-form
            :model="editForm"
            :rules="addRules"
            ref="editForm"
            label-width="80px"
            size="medium"
          >
            <el-form-item label="权限名称" prop="name">
              <el-input v-model="editForm.name"></el-input>
            </el-form-item>
            <el-form-item label="接口地址">
              <el-input v-model="editForm.url"></el-input>
            </el-form-item>
            <el-form-item label="父级菜单">
              <el-select
                v-model="editForm.pid"
                @change="getChildMenuEdit"
                size="medium"
              >
                <el-option
                  v-for="item in menu_data"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属菜单">
              <el-select v-model="editForm.menu_id" size="medium">
                <el-option
                  v-for="item in childMenuList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>

          <div
            slot="footer"
            style="display: flex; justify-content: flex-end; gap: 10px"
          >
            <el-button size="medium" @click="editDialogVisibleMobile = false"
              >取消</el-button
            >
            <el-button
              type="primary"
              size="medium"
              @click="submitEditMenuMobile"
              >确认修改</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      searchParams: { page: 1, page_size: 10, name: "" },
      pageSizes: [10, 20, 50, 100, 200, 500, 800, 1000, 2000],
      menu_data: [],
      childMenuList: [],

      // ====== PC 弹窗 ======
      addDialogVisible: false,
      editDialogVisible: false,

      // ====== 移动端 独立弹窗 ======
      addDialogVisibleMobile: false,
      editDialogVisibleMobile: false,

      addForm: { name: "", url: "", pid: "", menu_id: "" },
      editForm: { name: "", url: "", pid: "", menu_id: "" },
      permission_id: "",

      addRules: {
        name: [{ required: true, message: "请输入权限名称", trigger: "blur" }],
      },

      // 搜索折叠
      searchCollapsed: true,
    };
  },
  created() {
    this.getMenuList();
  },
  methods: {
    getMenuList() {
      this.loading = true;
      api.permissions
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.pageInfo.total = res.data.data.total;
            this.menu_data = res.data.data.menu_data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getChildMenu(pid) {
      let parent = this.menu_data.find((item) => item.id == pid);
      this.childMenuList = parent ? parent.children : [];
      this.addForm.menu_id = "";
    },
    getChildMenuEdit(pid) {
      let parent = this.menu_data.find((item) => item.id == pid);
      this.childMenuList = parent ? parent.children : [];
    },

    // ============================================== PC 方法 ==============================================
    openAddDialog() {
      this.addDialogVisible = true;
    },
    submitAddMenu() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        api.permissions
          .add(this.addForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.getMenuList();
              this.addDialogVisible = false;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    handleEdit(row) {
      let targetChild = null;
      let targetPid = "";
      for (let menu of this.menu_data) {
        if (!menu.children) continue;
        let child = menu.children.find((c) => c.id == row.menu_id);
        if (child) {
          targetChild = child;
          targetPid = menu.id;
          break;
        }
      }
      this.permission_id = row.id;
      this.editForm = {
        name: row.name,
        url: row.url,
        pid: targetPid,
        menu_id: row.menu_id,
      };
      this.getChildMenuEdit(targetPid);
      this.editDialogVisible = true;
    },
    submitEditMenu() {
      this.$refs.editForm.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const arr = {
          permission_id: this.permission_id,
          name: this.editForm.name,
          url: this.editForm.url,
          menu_id: this.editForm.menu_id,
        };
        api.permissions
          .edit(arr)
          .then((res) => {
            if (res.data.code == 1000) {
              this.getMenuList();
              this.editDialogVisible = false;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // ============================================== 移动端方法 ==============================================
    openAddDialogMobile() {
      this.resetAddForm();
      this.addDialogVisibleMobile = true;
    },
    submitAddMenuMobile() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        api.permissions
          .add(this.addForm)
          .then((res) => {
            if (res.data.code === 1000) {
              this.getMenuList();
              this.addDialogVisibleMobile = false;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    handleEditMobile(row) {
      let targetPid = "";
      for (let menu of this.menu_data) {
        if (!menu.children) continue;
        let child = menu.children.find((c) => c.id == row.menu_id);
        if (child) {
          targetPid = menu.id;
          break;
        }
      }
      this.permission_id = row.id;
      this.editForm = {
        name: row.name,
        url: row.url,
        pid: targetPid,
        menu_id: row.menu_id,
      };
      this.getChildMenuEdit(targetPid);
      this.editDialogVisibleMobile = true;
    },
    submitEditMenuMobile() {
      this.$refs.editForm.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        api.permissions
          .edit({
            permission_id: this.permission_id,
            name: this.editForm.name,
            url: this.editForm.url,
            menu_id: this.editForm.menu_id,
          })
          .then((res) => {
            if (res.data.code === 1000) {
              this.getMenuList();
              this.editDialogVisibleMobile = false;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    resetAddForm() {
      this.addForm = { name: "", url: "", pid: "", menu_id: "" };
      this.childMenuList = [];
      if (this.$refs.addForm) this.$refs.addForm.clearValidate();
    },
    resetEditForm() {
      this.editForm = { name: "", url: "", pid: "", menu_id: "" };
      this.childMenuList = [];
      if (this.$refs.editForm) this.$refs.editForm.clearValidate();
    },
    resetSearch() {
      this.searchParams.name = "";
      this.getMenuList();
    },

    handleDelete(row) {
      this.$confirm("此操作将永久删除该权限, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          api.permissions
            .del({ permission_id: row.id })
            .then((res) => {
              if (res.data.code == 1000) {
                this.getMenuList();
              }
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },

    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getMenuList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getMenuList();
    },

    // 折叠搜索
    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },
  },
};
</script>

<style scoped>
/* ====================== PC 样式 ====================== */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.dialog-footer {
  text-align: right;
}

/* ====================== 移动端样式 ====================== */
.mobile-menu-container {
  padding: 12px;
  box-sizing: border-box;
  max-width: 100vw;
  overflow-x: hidden;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  width: 100%;
  box-sizing: border-box;
}
.card-header {
  margin-bottom: 10px;
}
.info {
  flex: 1;
}
.name {
  font-size: 16px;
  font-weight: 500;
}
.id {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.7;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

/* 移动端分页容器（核心修复） */
.mobile-pagination-wrapper {
  margin-top: 15px;
  text-align: center;
  width: 100%;
  overflow-x: hidden;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/develop/permission.vue